import { createAction } from 'redux-starter-kit';
import { putInspectionReason } from '../inspectionReasons/inspectionReasonActions';
import { putOutcome } from '../outcomes/outcomeActions';
import { addInspectionDamages } from './inspectionDamageActions';
import { putVehicle } from '../vehicles/vehicleActions';
import { addInspectionNotes } from '../inspectionNotes/inspectionNoteActions';

/**
 * An action for storing an action in the state.
 * This inspection should be normalised before calling this action.
 * @example dispatch(putAction(inspection))
 */
export const putNormalizedInspection = createAction('PUT_INSPECTION');


export function putInspection(inspection) {
  return (dispatch) => {
    const normalizedInspection = { ...inspection };

    // Store the vehicle.
    const { vehicle } = inspection;
    dispatch(putVehicle(vehicle));
    normalizedInspection.vehicle = vehicle ? vehicle.vehicleId : null;

    // Store the damages.
    const { newDamages, existingDamages } = inspection;
    dispatch(addInspectionDamages(newDamages));
    dispatch(addInspectionDamages(existingDamages));
    normalizedInspection.newDamages = newDamages ? newDamages.map(dmg => dmg.damageId) : [];
    normalizedInspection.existingDamages = existingDamages ? existingDamages.map(dmg => dmg.damageId) : [];

    // Store the notes.
    const { notes } = inspection;
    dispatch(addInspectionNotes(notes));
    normalizedInspection.notes = notes ? notes.map(note => note.noteId) : [];

    // Store the reason.
    const { reason } = inspection;
    dispatch(putInspectionReason(reason));
    normalizedInspection.reason = reason ? reason.reasonCode : null;

    // Store the outcome (now optional).
    const { outcome } = inspection;
    if (outcome) {
      dispatch(putOutcome(outcome));
    }
    normalizedInspection.outcome = outcome ? outcome.outcomeCode : null;

    dispatch(putNormalizedInspection(normalizedInspection));
  };
}
